import { IApplication } from "@rentiohq/shared-frontend/dist/types/application.types";
import { createContext } from "react";
import { IDropArea } from "../PropertyDetailApplications";

// Module-level drag state — completely outside React.
// dragHoveredTabId: last tab the cursor was over (never cleared during drag)
// tabLeftAt: timestamp when the cursor left the tab zone
// dragFinalDropTarget: snapshot taken at mouseup — this is what onDragEnd reads
export let dragHoveredTabId: string | null = null;
export let tabLeftAt: number = 0;
export let dragFinalDropTarget: string | null = null;

export function setDragHoveredTabId(id: string | null) {
  dragHoveredTabId = id;
  if (id !== null) {
    tabLeftAt = 0; // On a tab — reset the "left" timestamp
  }
}
export function markTabLeft() {
  tabLeftAt = Date.now();
}
export function setDragFinalDropTarget(id: string | null) {
  dragFinalDropTarget = id;
}
export function resetDragState() {
  dragHoveredTabId = null;
  tabLeftAt = 0;
  dragFinalDropTarget = null;
}

interface IDragAndDropContext {
  selectedItems: IApplication[];
  allDropAreas: IDropArea[];
  onSelectItem: (item: IApplication) => void;
  onSelectAll: (item: IApplication[]) => void;
  onUnselectItem: (item: IApplication) => void;
  onUnselectAll: (item: IApplication[]) => void;
  setAllDropAreas: (dropAreas: IDropArea[]) => void;
  replaceSelectedItems: (items: IApplication[]) => void;
  isGlobalDragging: boolean;
  setIsGlobalDragging: (isDragging: boolean) => void;
  hoveredTab: string | null;
  setHoveredTab: (tabId: string | null) => void;
  hoveredTabRef: React.MutableRefObject<string | null>;
}

export const DragAndDropContext = createContext<IDragAndDropContext>({
  selectedItems: [],
  allDropAreas: [],
  setAllDropAreas: () => {},
  onSelectAll: () => {},
  onSelectItem: () => {},
  onUnselectItem: () => {},
  onUnselectAll: () => {},
  replaceSelectedItems: () => {},
  isGlobalDragging: false,
  setIsGlobalDragging: () => {},
  hoveredTab: null,
  setHoveredTab: () => {},
  hoveredTabRef: { current: null },
});
